import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LetterFeatures } from '../models/letterfeatures.model';
import { map } from 'rxjs/operators';
import 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class LetterService {
  private Url: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
  }

  getLetterFeatures() {
    return this.http.get<LetterFeatures>(this.Url + 'api/letter/GetFeatures');
  }

  sendLetterPack(letterPack: LetterFeatures, fileName: string) {
    let params = new HttpParams().set('firstLetter', letterPack.firstLetter.toString()).set('lastLetter', letterPack.lastLetter.toString()).set('totalLetters', letterPack.totalLetters.toString());
    //return this.http.post(this.Url + `api/letter?fileName=${fileName}`, letterPack);
    return this.http.get(this.Url + 'api/letter', { params: params, responseType: 'blob' })
      .subscribe((blob: Blob) => {
        console.log('report is downloaded');

        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, fileName);
        }
        else {
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          else {
            //html5 download not supported
          }
        }
      });
  }

  sendLetter(Letter: number) {
    let params = new HttpParams().set('Letter', Letter.toString());
    //return this.http.post(this.Url + `api/letter?fileName=${fileName}`, letterPack);
    return this.http.get(this.Url + 'api/letter/DownloadOneLetters', { params: params, responseType: 'blob' });
      
  }

  downloadSecondLetter(idDebtor: number) {
    let params = new HttpParams().set('idDebtor', idDebtor.toString());
    //return this.http.post(this.Url + `api/letter?fileName=${fileName}`, letterPack);
    return this.http.get(this.Url + 'api/letter/DownloadSecondLetter', { params: params, responseType: 'blob' });
  }

  downloadThirdLetter(idDebtor: number) {
    let params = new HttpParams().set('idDebtor', idDebtor.toString());
    //return this.http.post(this.Url + `api/letter?fileName=${fileName}`, letterPack);
    return this.http.get(this.Url + 'api/letter/DownloadThirdLetter', { params: params, responseType: 'blob' });
  }
}
